import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { useStaffAuth } from '../stores/staffAuth';

export default function LoginStaff() {
  const [email,    setEmail]    = useState('');
  const [pass,     setPass]     = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [err,      setErr]      = useState<string | null>(null);
  const nav        = useNavigate();
  const setSession = useStaffAuth((s) => s.setSession);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!email.trim()) return setErr('Ingresá tu correo electrónico');
    if (!pass)         return setErr('Ingresá tu contraseña');
    setLoading(true);
    setErr(null);
    try {
      const data = await api<{ access: string; refresh: string; staff: any }>(
        '/staff?action=login',
        { method: 'POST', body: JSON.stringify({ email: email.trim().toLowerCase(), password: pass }), auth: false }
      );
      setSession(data.access, data.refresh, data.staff);
      nav('/staff', { replace: true });
    } catch (e: any) {
      setErr(e.message || 'Acceso denegado');
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-6" style={{ backgroundColor: '#f2f2f2' }}>
      <div className="w-full max-w-sm">

        {/* Logo */}
        <div className="flex flex-col items-center mb-8">
          <img src={`${import.meta.env.BASE_URL}icon.png`} alt="CiudadApp" className="w-20 h-20 rounded-2xl mb-4 shadow-md" />
          <h1 className="text-2xl font-extrabold text-gray-900 tracking-tight">CiudadApp</h1>
          <div className="bg-brand-50 text-brand-600 text-xs font-bold px-3 py-1 rounded-full mt-2 tracking-widest uppercase">
            Personal Municipal
          </div>
        </div>

        {/* Card */}
        <div className="rounded-2xl p-6 shadow-sm" style={{ backgroundColor: '#ffffff', border: '1px solid #6e6b6b' }}>
          <p className="font-bold text-gray-900 text-sm mb-1">Acceso de personal</p>
          <p className="text-gray-400 text-xs mb-5">Usá tu correo institucional para ingresar</p>

          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-semibold mb-1.5" style={{ color: '#64748b' }}>Correo electrónico</label>
              <input
                type="email"
                autoComplete="username"
                autoCapitalize="none"
                autoCorrect="off"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="usuario@municipio.gob.ar"
                className="w-full rounded-xl px-4 py-3 text-sm outline-none"
                style={{ backgroundColor: '#ffffff', border: '1px solid #6e6b6b', color: '#303030' }}
              />
            </div>

            <div>
              <label className="block text-xs font-semibold mb-1.5" style={{ color: '#64748b' }}>Contraseña</label>
              <div className="relative">
                <input
                  type={showPass ? 'text' : 'password'}
                  autoComplete="current-password"
                  value={pass}
                  onChange={(e) => setPass(e.target.value)}
                  placeholder="••••••••"
                  className="w-full rounded-xl px-4 py-3 pr-12 text-sm outline-none"
                  style={{ backgroundColor: '#ffffff', border: '1px solid #6e6b6b', color: '#303030' }}
                />
                <button
                  type="button"
                  onClick={() => setShowPass((v) => !v)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-xl leading-none"
                  tabIndex={-1}
                >
                  {showPass ? '🐵' : '🙈'}
                </button>
              </div>
            </div>

            {err && (
              <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-xl p-3">{err}</div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-brand-600 hover:bg-brand-700 disabled:opacity-50 text-white rounded-xl py-3.5 font-bold text-base"
            >
              {loading ? 'Verificando…' : 'Ingresar'}
            </button>
          </form>
        </div>

        <button
          onClick={() => nav('/login')}
          className="w-full mt-5 text-center text-gray-400 text-sm py-3"
        >
          ← Volver al login de ciudadanos
        </button>

      </div>
    </main>
  );
}
